/**
 * Strips the `acid` query param from a location.search string, returning a
 * search string (including the leading "?", or "" if now empty) safe to use
 * when building a post-login redirect back to the current page.
 *
 * Without this, an invalid/stale `acid` the guest arrived with keeps getting
 * carried forward through the SSO round trip. useAcid()'s URL-param check
 * hard-stops on an invalid value instead of falling back to the correct acid
 * TryAuth just wrote to sessionStorage, so the guest would land back on the
 * page still reading as signed out — a loop with no way out via the URL.
 */
export const stripAcidFromSearch = (search) => {
  const params = new URLSearchParams(search);
  params.delete("acid");
  const query = params.toString();
  return query ? `?${query}` : "";
};
